import React, { useMemo } from 'react';
import { StoreUser } from '../../services/authService';
import useStoreOnboardingStatus from '../../hooks/useStoreOnboardingStatus';
import OnboardingStatusPanel from './OnboardingStatusPanel';

interface StoreOnboardingTabProps {
    storeId?: string;
    isSuperAdmin: boolean;
    shouldLoad: boolean;
    storeName?: string;
    subscriptionStatus?: string | null;
    storeUsers: StoreUser[];
    storeOwner: StoreUser | null;
}

const StoreOnboardingTab: React.FC<StoreOnboardingTabProps> = ({
    storeId,
    isSuperAdmin,
    shouldLoad,
    storeName,
    subscriptionStatus,
    storeUsers,
    storeOwner,
}) => {
    const storeManager = useMemo(() => {
        const manager = storeUsers.find((u) => {
            const r = (u.role || '').toLowerCase();
            return r === 'manager' || r.includes('manager');
        });
        return manager ?? null;
    }, [storeUsers]);

    const {
        onboardingLoading,
        onboardingError,
        onboardingData,
        onboardingSavingField,
        onboardingEmailRecipientStoreUserId,
        onboardingEmailContacts,
        onboardingEmailSending,
        onboardingEmailResult,
        setOnboardingEmailRecipientStoreUserId,
        loadOnboardingStatus,
        updateOnboardingField,
        handleSendOnboardingEmail,
    } = useStoreOnboardingStatus({
        storeId,
        isSuperAdmin,
        shouldLoad,
        storeUsers,
    });

    return (
        <OnboardingStatusPanel
            storeName={storeName}
            subscriptionStatus={subscriptionStatus}
            storeOwner={storeOwner}
            storeManager={storeManager}
            onboardingLoading={onboardingLoading}
            onboardingError={onboardingError}
            onboardingData={onboardingData}
            onboardingSavingField={onboardingSavingField}
            onboardingEmailRecipientStoreUserId={onboardingEmailRecipientStoreUserId}
            onboardingEmailContacts={onboardingEmailContacts}
            onboardingEmailSending={onboardingEmailSending}
            onboardingEmailResult={onboardingEmailResult}
            onSelectEmailRecipient={setOnboardingEmailRecipientStoreUserId}
            onSendOnboardingEmail={handleSendOnboardingEmail}
            onRetryLoadOnboarding={loadOnboardingStatus}
            onUpdateOnboardingField={(field, value) => {
                void updateOnboardingField(field, value);
            }}
        />
    );
};

export default StoreOnboardingTab;
